import { Button } from "@shared/ui/button";
import { CreditCard, Calendar, Printer, Mail, Send, FileText } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface ActionsTabProps {
  onProcessPayment: () => void;
  onCreateAgreement: () => void;
  onSendReminder: () => void;
  onSendNotice: () => void;
}

export const ActionsTab = ({
  onProcessPayment,
  onCreateAgreement,
  onSendReminder,
  onSendNotice,
}: ActionsTabProps) => {
  const navigate = useNavigate();
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-2">
        <Button onClick={() => {navigate(`/cx/payments/create`)}}>
          <CreditCard className="mr-2 h-4 w-4" />
          Process Payment
        </Button>
        <Button onClick={onCreateAgreement}>
          <Calendar className="mr-2 h-4 w-4" />
          Create Agreement
        </Button>
        <Button onClick={onSendReminder}>
          <Mail className="mr-2 h-4 w-4" />
          Send Reminder
        </Button>
        <Button onClick={onSendNotice}>
          <Send className="mr-2 h-4 w-4" />
          Send Notice
        </Button>
      </div>
    </div>
  );
};